import {
  CREATE_FUEL_SENSOR_CALIBRATION_SUCCESS,
  GET_FUEL_SENSOR_CALIBRATION_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  calibrationData: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {


    case GET_FUEL_SENSOR_CALIBRATION_SUCCESS: {

      return {
        ...state,
        calibrationData: action.data,
      }
    }

    case CREATE_FUEL_SENSOR_CALIBRATION_SUCCESS: {
      return {
        ...state,
        calibrationData: action.data,
      }
    }

    default:
      return state;
  }
}
